var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-snackbar",class:{
    opening: _vm.state === _vm.STATE_OPENING,
    opened: _vm.state === _vm.STATE_OPENED,
    closing: _vm.state === _vm.STATE_CLOSING,
    closed: _vm.state === _vm.STATE_CLOSED,
    left: _vm.direction === 'left',
    bottom: _vm.direction === 'bottom',
    success: _vm.success,
  }},[_c('div',{staticClass:"app-snackbar-wrapper"},[(_vm.title)?_c('h3',{staticClass:"title",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),(_vm.content)?_c('div',{staticClass:"content sm-line-height",domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }